import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              精彩预告
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              热门影视预告片与精彩片段一览
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.slice(0, 3).map((item) => (
              <div
                key={item.id}
                className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={`春色影视 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>
                    {item.views} 次播放
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {mediaItems.slice(3).map((item) => (
              <div
                key={item.id}
                className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={`春色影视 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>
                    {item.views} 次播放
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}